import * as React from 'react'
import Grid from '@mui/material/Grid'
import DataGridDemo from './detalhe'
import SingleRowSelectionGrid from './calendar'
import AutocompleteSKU from '../../components/common/AutocompleteSku'
import AutocompleteContrato from '../../components/common/AutocompleteContrato'
import AutocompleteProjeto from '../../components/common/AutocompleteProjeto'
import AutocompleteCentro from '../../components/common/AutocompleteCentro'
import AutocompleteJustificativa from '../../components/common/AutocompleteJustificativa'
import FormGroup from '@mui/material/FormGroup';
import MultipleSelectCheckmarks from './selectTipoRegistro'
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Fab from '@mui/material/Fab';
import CustomizedSlider from './aderenciaMedidor'


/* TOOLBAR */
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton"
import NavigationIcon from '@mui/icons-material/Navigation';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BaseSelect from './selectionSteps'

const ForecastSelection = () => {
    return (
        <div className='containerFlex'>
            <div className="containerUmTerco">
                <Grid container spacing={2} sx={{ width: '98%' }}>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <SingleRowSelectionGrid />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <AutocompleteSKU />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <AutocompleteContrato />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <MultipleSelectCheckmarks />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <BaseSelect />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <CustomizedSlider />
                    </Grid>
                    <Grid item sm={12} lg={12} textAlign='center' >
                        <Fab variant="extended" size='small' >
                            <FilterAltIcon sx={{ mr: 1 }} />
                            Filtrar
                        </Fab>
                    </Grid>
                </Grid>
            </div>
            <div className="containerDoisTerco">
                <DataGridDemo />
            </div>
        </div>
    );
}

export default ForecastSelection